// extracted by mini-css-extract-plugin
export default {"scrollContainer":"TableProductsProvidersWrapper_scrollContainer__z0jaa","gridContainer":"TableProductsProvidersWrapper_gridContainer__y0AJY"};